import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 2.5V8M8 8V13.5M8 8H2.5M8 8H13.5", stroke: "#5090EA", strokeWidth: 1.5, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
